import { handleActions, combineActions } from 'redux-actions';
import actions from '../actions';

const {
  status: { edit: editStatus },
  vatId: { edit: editVatId },
  modal: { toggle },
  submit,
  reset,
} = actions.invoice;

const defaultState = {
  active: false,
  submitting: false,
  vatId: '',
  status: {},
};

export default handleActions(
  {
    [combineActions(editStatus, editVatId)]: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
    [toggle]: state => ({ ...state, active: !state.active }),
    [submit.enable]: state => ({ ...state, submitting: true }),
    [submit.disable]: state => ({ ...state, submitting: false }),
    [reset]: () => defaultState,
  },
  defaultState
);



// WEBPACK FOOTER //
// ./src/reducers/invoice.js